






import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'

@Component<TextWithHighlight>({})
export default class TextWithHighlight extends Vue {
    @Prop({type: String, default: ''}) public text!: string
    @Prop({type: Array, default: () => []}) public highlights!: string[]
    @Prop({type: Number, default: 0}) public height!: number

    public get html() {
        let coloredText = this.text
        this.highlights
            // !!NOTE: should sort by length at first to handle names with same prefix.
            // When having both `@Region:NZ` and `@Region:NZ(Staff)`. We only highlighted `@Region:NZ`
            // instead of `@Region:NZ(Staff)` without sort.
            .sort((a, b) => b.length - a.length)
            .forEach(word => {
                coloredText = coloredText.replace(word, this.wrapHighlight(word))
            })
        return coloredText
    }

    public get style() {
        const pStyle = {}
        if (this.height) {
            pStyle['height'] = this.height + 'px'
            pStyle['overflow'] = 'hidden'
        }
        return pStyle
    }

    public wrapHighlight(word) {
        return `<b class='default-highlight'>${word}</b>`
    }
}
